import classNames from "classnames";
import { HTMLAttributes } from "react";
import { AbcdeRiskValue } from "../schema";
interface SingleLetterRiskBandProps {
  rating: AbcdeRiskValue | "?";
  size?: number;
  fullWidth?: boolean;
  /** Rating is not calculated for the selection, as opposed to missing data. */
  notApplicable?: boolean;
}
export const SingleLetterRiskBand = ({
  rating,
  size = 64,
  fullWidth = false,
  notApplicable = false
}: SingleLetterRiskBandProps) => {
  const isNoDataRating = rating === "?";
  const colourClasses: HTMLAttributes<HTMLDivElement>["className"] = classNames({
    "bg-green-600 text-green-50 border-green-700 shadow-green-600/30 dark:shadow-green-800/70": rating === "A",
    "bg-yellow-500 text-yellow-50 border-yellow-600 shadow-yellow-500/50 dark:shadow-yellow-800/70": rating === "B",
    "bg-red-600 text-red-50 border-red-800 shadow-red-600/30 dark:border-red-400 dark:shadow-red-800/70": rating === "C",
    "bg-red-800 text-red-50 border-red-950 shadow-red-800/30 dark:border-red-500 dark:shadow-red-800/70": rating === "D",
    "bg-red-950 text-red-50 border-red-700 shadow-red-950/30 dark:border-red-800 dark:shadow-red-900/70": rating === "E",
    "bg-gray-700 text-gray-100 border-gray-800 shadow-gray-800/40 dark:bg-gray-600 dark:border-gray-400 dark:shadow-gray-50/50": rating === "?"
  });
  const getBorderSize = () => {
    if (size >= 96) return "6px";
    if (size >= 64) return "4px";
    if (size >= 48) return "3px";
    if (size >= 32) return "2px";
    return "1px";
  };
  const NoRating = () => <span className="p-4 leading-none" style={{
    fontSize: `${Math.max(size * 0.2, 10)}px`
  }} data-sentry-component="NoRating" data-sentry-source-file="SingleLetterRiskBand.tsx">
      {size > 32 ? "NO DATA" : "NA"}
    </span>;
  const getShadowSize = () => {
    if (size >= 96) return "shadow-lg";
    if (size >= 64) return "shadow-md";
    if (size >= 48) return "shadow-sm";
    if (size >= 32) return "shadow-sm";
    return "shadow-sm";
  };
  return <div className={classNames(["flex aspect-square flex-shrink-0 items-center justify-center rounded-full border", notApplicable ? "border-gray-200 bg-gray-100 text-gray-400 dark:border-gray-700 dark:bg-gray-800" : colourClasses, !notApplicable && getShadowSize(), fullWidth && "w-full"])} style={{
    borderWidth: getBorderSize(),
    ...(fullWidth ? {} : {
      width: `${size}px`,
      height: `${size}px`
    })
  }} data-sentry-component="SingleLetterRiskBand" data-sentry-source-file="SingleLetterRiskBand.tsx">
      <span className="flex items-center justify-center text-center font-bold leading-[0.5]" style={{
      fontSize: `${Math.max(size * 0.5, 14)}px`
    }}>
        {notApplicable ? <span style={{
        fontSize: `${Math.max(size * 0.3, 9)}px`
      }}>N/A</span> : isNoDataRating ? <NoRating /> : rating}
      </span>
    </div>;
};